import React from 'react';
import {CONFIG_PAGE_ROWS, CONFIG_TABLE_MAX_X} from "../constants/constants";
import {getAccessesByClientId} from "../services/AccessesService";
import EntriesIterator from "../components/EntriesIterator";
import DialogTextInputFilter from "../components/DialogTextInputFilter";
import Moment from 'react-moment';
import moment from "moment-timezone";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {Descriptions, Radio, Table, message} from 'antd';
import {isAdminRole} from "../services/UsersService";
import icon_internet from "../resources/os/icon_internet.svg";
import icon_ie from "../resources/os/icon_ie.svg";
import icon_firefox from "../resources/os/icon_firefox.svg";
import icon_chrome from "../resources/os/icon_chrome.svg";
import icon_opera from "../resources/os/icon_opera.svg";
import icon_safari from "../resources/os/icon_safari.svg";
import icon_uc from "../resources/os/icon_uc.svg";
import icon_samsung_internet from "../resources/os/icon_samsung_internet.svg";
import icon_android from "../resources/os/icon_android.svg";
import icon_windows from "../resources/os/icon_windows.svg";
import icon_apple from "../resources/os/icon_apple.svg";
import icon_linux from "../resources/os/icon_linux.svg";

class Accesses extends EntriesIterator {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            range: 'today',
            page: 0,
            rows: CONFIG_PAGE_ROWS,
            total: 0,
            showAll: this.props.showAll === true
        }
    }

    processPaginatedRequest = (page, rows, filters) => {
        return getAccessesByClientId(this.state.showAll, this.state.range, this.props.client, page, rows, filters);
    };

    updateRange(value) {
        const previous = this.state.range;
        if (!value)
            value = 'today';
        if (previous !== value) {
            this.setState({
                range: value,
                page: 0,
                total: 0
            }, () => {
                this.onPage(0, this.state.filters)
            })
        }
    }

    renderAdditionalColumns() {
        const additionalColumns = [];
        if (this.state.showAll) {
            additionalColumns.push({
                title: 'Usuario',
                dataIndex: 'entityId',
                key: 'entityId',
                render: (text, record) => {
                    const id = record.entityId;
                    const name = record.entityName;
                    const source = record.sourceId;
                    const showBlockDetails = id !== name;
                    return record.entityType && record.entityType.endsWith(".Invite") ?
                        <div>
                            <span className="ant-tag-blue">Invite</span> [{source}] {name}
                        </div>
                        :
                        showBlockDetails ?
                            <div className="block-details">
                                <div>{id}</div>
                                <sub>{name}</sub>
                            </div>
                            :
                            <div>{id}</div>
                },
                filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
                    <DialogTextInputFilter
                        placeholder={'Usuario'}
                        selectedKeys={selectedKeys}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onSearch={this.handleFilterSearch(selectedKeys, confirm)}
                        onReset={this.handleFilterReset(clearFilters)}/>
                ),
            });
            if (isAdminRole()) {
                additionalColumns.push({
                    title: 'Distancia',
                    dataIndex: 'fingerPrint',
                    key: 'fingerPrint',
                    render: fingerPrint => Math.round(fingerPrint.distance) + ' m'
                });
            }
        }
        return additionalColumns;
    }

    renderView() {
        const columns = [{
            dataIndex: 'fingerPrint',
            key: 'fingerPrint',
            render: fingerPrint => this.renderIconSet(fingerPrint),
            width: '5em',
            align: 'center'
        }, {
            title: 'Fecha',
            dataIndex: 'date',
            key: 'date',
            render: date => <Moment date={date} format="DD/MM/YYYY"/>
        }, {
            title: 'Hora',
            dataIndex: 'date',
            key: 'hour',
            render: date => <Moment date={date} format="hh:mm:ss a"/>
        }, {
            title: 'Acción',
            key: 'action.name',
            render: access => {
                return access.action.name + (access.success ? '' : this.getDetails(access.details))
            },
            filters: this.state && this.state.filterSource ? this.state.filterSource['action.name'] : [],
        }];

        const moreColumns = this.renderAdditionalColumns();
        if (moreColumns != null) {
            columns.push(...moreColumns);
        }

        return <div>
            <div className="action-separator">
                <Radio.Group buttonStyle="solid" value={this.state.range}
                             onChange={(e) => this.updateRange(e.target.value)}>
                    <Radio.Button value="today">Hoy</Radio.Button>
                    <Radio.Button value="week">Esta semana</Radio.Button>
                    <Radio.Button value="month">Este mes</Radio.Button>
                    <Radio.Button value="all">Todo</Radio.Button>
                </Radio.Group>
            </div>

            <Table
                rowClassName={(record, index) => {
                        const divider = index < this.state.data.length - 2 && moment(record.date).format('DD/MM/YYYY') !== moment(this.state.data[index + 1].date).format('DD/MM/YYYY') ? "row-divider" : ""
                        const error = record.success ? "" : " row-error";
                        return divider + error;
                    }
                }
                dataSource={this.state.data}
                columns={columns} bordered loading={this.state.loading}
                pagination={this.getPagination()} size="small" onChange={this.handleStateChange} rowKey="id"
                expandedRowRender={access =>
                    <div>
                        <Descriptions size={"small"} column={1}>
                            <Descriptions.Item label={access.fingerPrint.hash}>{access.fingerPrint.data.userAgent}</Descriptions.Item>
                            <Descriptions.Item label="Ubicación">
                                {
                                    access.fingerPrint.latitude && access.fingerPrint.longitude ?
                                        <div>
                                            <CopyToClipboard id={access.id} text={access.fingerPrint.latitude + ',' + access.fingerPrint.longitude} onCopy={() => message.open({type: 'success', content: 'Copiado!', duration: 2})}>
                                                <a href="#copy">{access.fingerPrint.latitude + ',' + access.fingerPrint.longitude}</a>
                                            </CopyToClipboard>
                                            {
                                                access.fingerPrint.distance && access.fingerPrint.distance !== -1 ?
                                                    <span className="mrg-left">({Math.round(access.fingerPrint.distance)} metros)</span> : null
                                            }
                                        </div>: 'Desconocido'
                                }
                            </Descriptions.Item>
                        </Descriptions>
                    </div>
                }
                scroll={{ x: CONFIG_TABLE_MAX_X }}/>
        </div>
    }

    renderIconSet(fingerPrint) {
        let iconOS = null;
        let iconBrowser = icon_internet;
        if (fingerPrint) {
            if (fingerPrint['data']['appInfo'] && fingerPrint['data']['userAgent']) {
                iconOS = this.getSOInfo(fingerPrint['data']['userAgent']);
                const version = fingerPrint['data']['appInfo']['version'];
                return <div className="access-info">
                    <img alt="" height={20} src={iconOS}/>
                    <span className="version">{version}</span>
                </div>;
            }
            if (fingerPrint['data']['userAgent']) {
                iconOS = this.getSOInfo(fingerPrint['data']['userAgent']);
                iconBrowser = this.getBrowserInfo(fingerPrint['data']['userAgent']);
                if (iconOS) {
                    return <div className="access-info">
                        <img alt="" height={20} src={iconOS}/>
                        <img alt="" height={20} src={iconBrowser}/>
                    </div>;
                }
            }
        }
        return <img alt="" height={20} src={iconBrowser}/>;
    }

    rowStyler(record, index) {
        const dateDiff = moment(record.date).format('DD/MM/YYYY') !== moment(this.state.data[index + 1].date).format('DD/MM/YYYY');
        const separator = index < this.state.data.length - 2 && dateDiff ? "row-divider" : "";

        return separator;
    }

    getBrowserInfo(userAgent) {
        const testBI = function (regexp) {
            return regexp.test(userAgent)
        }
        switch (true) {
            case testBI(/edg/i):
                return icon_ie;
            case testBI(/MSIE|trident/i):
                return icon_ie;
            case testBI(/firefox|fxios/i):
                return icon_firefox;
            case testBI(/OPR|opr\//i):
                return icon_opera;
            case testBI(/ucbrowser/i):
                return icon_uc;
            case testBI(/samsungbrowser/i):
                return icon_samsung_internet;
            case testBI(/chrome|chromium|crios/i):
                return icon_chrome;
            case testBI(/safari/i):
                return icon_safari;
            default:
                return icon_internet;
        }
    }

    getSOInfo(userAgent) {
        const testOS = function (regexp) {
            return regexp.test(userAgent)
        }
        switch (true) {
            case testOS(/Android/i):
                return icon_android;
            case testOS(/Iphone|Mac/i):
                return icon_apple;
            case testOS(/Linux|X11/i):
                return icon_linux
            case testOS(/Win/i):
                return icon_windows;
            default:
                return null;
        }
    }

    getDetails(details) {
        if ('DISABLED' === details) {
            return ' (deshabilitado)';
        }
        if ('DISTANCE' === details) {
            return ' (muy lejos)';
        }
        return ' (offline)';
    }
}

export default Accesses;


// WEBPACK FOOTER //
// ./src/app/views/Accesses.js